module.exports = __webpack_public_path__ + "img/pic_rorate3.2be76531.png";